;(function () {
    let recaptcha = document.createElement('script')
    recaptcha.type = 'text/javascript'
    recaptcha.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=onLoadCallback&render=explicit')
    recaptcha.setAttribute('async', true)
    recaptcha.setAttribute('defer', true)
    document.getElementsByTagName('head')[0].appendChild(recaptcha)
})()

let onLoadCallback

const promise = new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
        reject()
    }, 30 * 1000)

    onLoadCallback = () => {
        resolve(window.grecaptcha)
        clearTimeout(timeout)
    }
})

// It's necessary to register 'onLoadCallback' globally after the function declaration.
window.onLoadCallback = onLoadCallback
// END

export default promise
